import { updateObject } from '../utility';

const initialState = {
  customerServiceData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CUSTOMERSERVICE_DATA': {
      return updateObject(state, {
        customerServiceData: action.payload,
      });
    }
    default:
      return state;
  }
};

export default reducer;
